import { render } from "./FormAddress.vue?vue&type=template&id=dde41cae&ts=true"
import script from "./FormAddress.vue?vue&type=script&lang=ts"
export * from "./FormAddress.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__